import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { OrderActivity } from '../../../common/model/dto/order/order-activity';
import Colours from '../../../design-system/colours';
import Variables from '../../../design-system/variables';
import OvListTable from '../atoms/OvListTable';
import OvListTableHeaderField from '../atoms/OvListTableHeaderField';
import OvListTableRow from '../atoms/OvListTableRow';
import OvOrderActivityListRow from './OvOrderActivityListRow';

const OvOrderActivityList: FC<{ orderActivities: OrderActivity[] }> = ({
  orderActivities,
}) => {
  const { t } = useTranslation();
  const headerNames = [
    'orders.orderActivities.tableHeaders.date',
    'orders.orderActivities.tableHeaders.status',
    'orders.orderActivities.tableHeaders.action',
    'orders.orderActivities.tableHeaders.initiator',
    'orders.orderActivities.tableHeaders.source',
    'orders.orderActivities.tableHeaders.operation',
  ];

  return (
    <WrapperBox>
      <StyledSectionHeader>
        {t('orders.details.activities')}
      </StyledSectionHeader>

      <ScrollRegion
        role="region"
        aria-label={t('orders.details.activitiesRegion')}
        tabIndex={0}
      >
        <OvListTable>
          <OvListTableRow>
            {headerNames.map((headerName) => (
              <OvListTableHeaderField key={headerName}>
                {t(headerName)}
              </OvListTableHeaderField>
            ))}
          </OvListTableRow>

          {orderActivities.map((orderActivity) => (
            <OvListTableRow key={orderActivity.id}>
              <OvOrderActivityListRow orderActivity={orderActivity} />
            </OvListTableRow>
          ))}
        </OvListTable>
      </ScrollRegion>
    </WrapperBox>
  );
};

export default OvOrderActivityList;

const WrapperBox = styled.section`
  background-color: ${Colours.WHITE};
  border-radius: ${Variables.borderRadius.LARGE};
  box-shadow: ${Variables.boxShadow.alternateBox};
  padding: 1.375rem 1.5rem;
`;

const StyledSectionHeader = styled.h2`
  margin: 0 0 1rem;
  font-size: ${Variables.fontSizes.LARGE};
`;

const ScrollRegion = styled.div`
  overflow-x: auto;

  &:focus-visible {
    outline: 3px solid ${Colours.OV_ACCENT_BLUE};
    outline-offset: 2px;
  }

  table {
    min-width: 45rem;
  }

  th:first-child,
  td:first-child {
    padding-left: 0;
  }
`;
